var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitterIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 19,
    height: 17,
    viewBox: "0 0 19 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "icahv6xqsa",
    d: "M0 0.261L19 0.261 19 16.261 0 16.261z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "emgrxkdq1b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#icahv6xqsa"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M19 2.231c-.461.734-1.044 1.35-1.72 1.875-.133.104-.176.207-.172.382.047 1.865-.347 3.636-1.13 5.313-.934 2.006-2.295 3.63-4.14 4.807-1.308.835-2.734 1.332-4.258 1.542-1.074.148-2.148.15-3.219-.008-1.552-.23-2.996-.772-4.323-1.638-.01-.006-.015-.017-.038-.045 2.11.2 4.007-.334 5.725-1.662-1.79-.163-2.982-1.09-3.653-2.812.599.068 1.157.087 1.733-.081C1.544 9.326.637 7.264.735 5.912c.53.273 1.08.458 1.726.472-.854-.641-1.4-1.447-1.62-2.469-.22-1.017-.064-1.978.434-2.904 2.12 2.57 4.793 3.985 8.065 4.215-.022-.261-.053-.506-.062-.75C9.208 2.482 10.482.76 12.37.355c1.324-.283 2.504.067 3.5 1.017.137.132.25.156.424.112.716-.181 1.4-.442 2.046-.812.048-.027.098-.05.184-.095-.301.94-.85 1.63-1.602 2.199.229-.044.46-.08.687-.133.23-.054.457-.12.682-.192.231-.075.457-.165.685-.25l.025.029",
    mask: "url(#emgrxkdq1b)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterIcon);
export default __webpack_public_path__ + "static/media/twitter-icon.489fb96f.svg";
export { ForwardRef as ReactComponent };